"use client";

import { Button } from "@/components/ui/button";
import {
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";

type Option = { label: string; value: string };

interface ISelectProps {
  placeholder?: string;
  options: Option[];
  selectedOptions: string[];
  onValueChange: (value: string[]) => void;
}
const MultiSelect = ({
  placeholder='Select options',
  options: values,
  selectedOptions: selectedItems,
  onValueChange,
}: ISelectProps) => {

  const handleSelectChange = (value: string) => {
    if (!selectedItems?.includes(value)) {
      onValueChange([...selectedItems || [], value]);
    } else {
      const referencedArray = [...selectedItems || []];
      const indexOfItemToBeRemoved = referencedArray.indexOf(value);
      referencedArray.splice(indexOfItemToBeRemoved, 1);
      onValueChange(referencedArray);
    }
  };

  const isOptionSelected = (value: string): boolean => {
    return selectedItems?.includes(value) ? true : false;
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild className="w-full">
          <Button
            variant="outline"
            className="w-full flex items-center justify-between"
          >
            {selectedItems?.length > 0 
            ? selectedItems?.map(v => values?.find(o=>o.value === v)?.label).join(', ')
            : placeholder
            }
            <ChevronDown className="h-4 w-4 opacity-50" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="w-56"
          onCloseAutoFocus={(e) => e.preventDefault()}
        >
          {values.map((value: ISelectProps["options"][0], index: number) => {
            return (
              <DropdownMenuCheckboxItem
                onSelect={(e) => e.preventDefault()}
                key={index}
                checked={isOptionSelected(value.value)}
                onCheckedChange={() => handleSelectChange(value.value)}
              >
                {value.label}
              </DropdownMenuCheckboxItem>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};

export default MultiSelect;